import { render, staticRenderFns } from "./SectionHeading.vue?vue&type=template&id=2259f27e&"
import script from "./SectionHeading.vue?vue&type=script&lang=js&"
export * from "./SectionHeading.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VIcon,VTextField})
